import { WORKFLOW_STEP_NAME_PATTERN } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Button, Field, Input, Sheet, SheetContent } from "@sagot/ui";
import type { Step } from "../types";
import type { FlowContext } from "./flow-context";
import { StepForm } from "./step-form";

interface StepSheetProps {
  step: Step;
  flow: FlowContext;
  disabled: boolean;
  onChange: (step: Step) => void;
  onClose: () => void;
}

/** Side sheet that edits one step (its own fields + an optional display name). */
export function StepSheet({ step, flow, disabled, onChange, onClose }: StepSheetProps) {
  const { t } = useTranslation();
  const nameInvalid = step.name !== undefined && !WORKFLOW_STEP_NAME_PATTERN.test(step.name);
  return (
    <Sheet open onOpenChange={(open) => { if (!open) onClose(); }}>
      <SheetContent
        title={t(`engage.workflows.steps.${step.type}`)}
        description={t("engage.workflows.builder.editStep")}
        closeLabel={t("common.close")}
        className="max-w-lg"
        footer={<Button onClick={onClose}>{t("engage.workflows.builder.done")}</Button>}
      >
        <div className="space-y-5">
          <Field label={t("engage.workflows.builder.stepName")} hint={t("engage.workflows.builder.stepNameHint")} error={nameInvalid ? t("engage.workflows.builder.stepNameInvalid") : undefined}>
            <Input maxLength={80} disabled={disabled} value={step.name ?? ""} placeholder={step.id} onChange={(e) => { onChange({ ...step, name: e.target.value || undefined }); }} />
          </Field>
          <StepForm step={step} disabled={disabled} onChange={onChange} {...flow} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
